import { render, staticRenderFns } from "./role_page.vue?vue&type=template&id=02a65e0e&scoped=true"
import script from "./role_page.vue?vue&type=script&lang=js"
export * from "./role_page.vue?vue&type=script&lang=js"
import style0 from "./role_page.vue?vue&type=style&index=0&id=02a65e0e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a65e0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a65e0e')) {
      api.createRecord('02a65e0e', component.options)
    } else {
      api.reload('02a65e0e', component.options)
    }
    module.hot.accept("./role_page.vue?vue&type=template&id=02a65e0e&scoped=true", function () {
      api.rerender('02a65e0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/role_page.vue"
export default component.exports